import { FC } from 'react';
import { DetailsBooking } from 'types';
import StateMessaging from '../BookingDetails/StateMessaging';
import { FailedScheduledPaymentContainer } from '../Alerts/Inline/FailedScheduledPayment';
import { ScheduledPaymentCreditCardExpiredContainer } from '../Alerts/Inline/ScheduledPaymentCreditCardExpired';
import { InPathFlightBookingAlert } from 'components/InPathFlightBookingAlert';
import { showPaidByQantasTravelPass } from '../helpers';
import QantasPassNotification from './components/QantasPassNotification';

interface BookingDetailsProps {
  booking: DetailsBooking;
}

const BookingNotifications: FC<BookingDetailsProps> = ({ booking }) => {
  const showQantasPassNotification = showPaidByQantasTravelPass(booking);

  return (
    <>
      {showQantasPassNotification && <QantasPassNotification />}
      <StateMessaging booking={booking} />
      <InPathFlightBookingAlert />
      <FailedScheduledPaymentContainer />
      <ScheduledPaymentCreditCardExpiredContainer />
    </>
  );
};

export default BookingNotifications;
